// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.102.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.102.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aiiif-item {
    min-height: 45px;
    width: 120px;
    padding: 8px;
    margin: 8px;
    border-radius: 5px;
    cursor: pointer;
}

.aiiif-item.active {
    background-color: #f3f2f1;
}

.aiiif-item-thumbnail {
    background-size: contain;
    background-repeat: no-repeat;
    width: 72px;
    height: 72px;
    background-position: center;
    margin: 0 auto;
}

.aiiif-item-thumbnail svg, .aiiif-item-thumbnail .svg-inline--fa {
    width: 90%;
    height: 90%;
}

.aiiif-item-thumbnail .fa-folder {
    color: #7cd6fa;
}

.aiiif-item-thumbnail .fa-file-alt {
    color: #a9a9a9;
}

.aiiif-item-label {
    line-height: 14px;
    text-align: center;
    word-break: break-all;
    font-size: 14px;
    margin-top: 4px;
}


.aiiif-list-view > .aiiif-item {
    width: 100%;
    text-align: left;
    padding: 4px 8px;
    margin: 2px;
    min-height: inherit;
    display: flex;
}

.aiiif-list-view > .aiiif-item > .aiiif-item-thumbnail {
    width: 16px;
    height: 16px;
    margin: 0;
}


.aiiif-list-view > .aiiif-item > .aiiif-item-label {
    margin: 0 0 0 6px;
}

.aiiif-bar-search {
    display: flex;
    margin-right: auto;
    flex-grow: 2;
}

.aiiif-bar-search > div {
    margin: auto 0;
}

.aiiif-bar-search > .MuiInputBase-root {
    width: 100%;
}

.aiiif-bar-search .fa-magnifying-glass {
    color: #484646;
    margin-right: 6px;
}
`, "",{"version":3,"sources":["webpack://./src/folder/item.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;IACxB,4BAA4B;IAC5B,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,eAAe;AACnB;;;AAGA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,SAAS;AACb;;;AAGA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB","sourcesContent":[".aiiif-item {\n    min-height: 45px;\n    width: 120px;\n    padding: 8px;\n    margin: 8px;\n    border-radius: 5px;\n    cursor: pointer;\n}\n\n.aiiif-item.active {\n    background-color: #f3f2f1;\n}\n\n.aiiif-item-thumbnail {\n    background-size: contain;\n    background-repeat: no-repeat;\n    width: 72px;\n    height: 72px;\n    background-position: center;\n    margin: 0 auto;\n}\n\n.aiiif-item-thumbnail svg, .aiiif-item-thumbnail .svg-inline--fa {\n    width: 90%;\n    height: 90%;\n}\n\n.aiiif-item-thumbnail .fa-folder {\n    color: #7cd6fa;\n}\n\n.aiiif-item-thumbnail .fa-file-alt {\n    color: #a9a9a9;\n}\n\n.aiiif-item-label {\n    line-height: 14px;\n    text-align: center;\n    word-break: break-all;\n    font-size: 14px;\n    margin-top: 4px;\n}\n\n\n.aiiif-list-view > .aiiif-item {\n    width: 100%;\n    text-align: left;\n    padding: 4px 8px;\n    margin: 2px;\n    min-height: inherit;\n    display: flex;\n}\n\n.aiiif-list-view > .aiiif-item > .aiiif-item-thumbnail {\n    width: 16px;\n    height: 16px;\n    margin: 0;\n}\n\n\n.aiiif-list-view > .aiiif-item > .aiiif-item-label {\n    margin: 0 0 0 6px;\n}\n\n.aiiif-bar-search {\n    display: flex;\n    margin-right: auto;\n    flex-grow: 2;\n}\n\n.aiiif-bar-search > div {\n    margin: auto 0;\n}\n\n.aiiif-bar-search > .MuiInputBase-root {\n    width: 100%;\n}\n\n.aiiif-bar-search .fa-magnifying-glass {\n    color: #484646;\n    margin-right: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
